module.exports = __webpack_public_path__ + "259d17e23558c1bf2d5b318e1922e937.png";